export default __webpack_public_path__ + "static/media/cyclopay-blue-logo2.de8e7236.svg";